// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import { PATH_MANAGEMENT } from '../../../routes/paths';
import { PermissionPath } from '../../../components/permission/PermissionPath';
import { useParams } from 'react-router';
import { can } from 'src/components/permission/Permission';
import useAuth from 'src/hooks/useAuth';

export const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  discount: getIcon('ic_discount_circle'),
  advertisement: getIcon('ic_advertising'),
  invoice: getIcon('ic_order'),
  product_category: getIcon('ic_category'),
  setting: getIcon('ic_settings'),
  role: getIcon('ic_permission'),
  settlement: getIcon('ic_financial'),
  price: getIcon('ic_price'),
  shop: getIcon('ic_shop'),
  courier: getIcon('ic_courier'),
  comment: getIcon('ic_comment'),
  further: getIcon('ic_further'),
  geoJson: getIcon('ic_geoJson'),
  logo: getIcon('ic_logo'),
  workingHours: getIcon('ic_workingHours'),
  address: getIcon('ic_address'),
  calendar: getIcon('ic_calendar'),
  invoice: getIcon('ic_invoice'),
  comment: getIcon('ic_comment'),
  setting: getIcon('ic_setting'),
  bank: getIcon('ic_bank'),
  courier: getIcon('ic_courier'),
  shop_user_block: getIcon('ic_user_block'),
  discountCode: getIcon('ic_discount-outline'),
};

const CourierNavConfig = () => {
  const { courierId } = useParams();
  const { user } = useAuth();
  const is_back = user.roles.find((item) => item.name == 'courier owner') ? true : false;
  const items = [
    {
      title: 'بازگشت',
      path: PATH_MANAGEMENT.management.courier.root,
      icon: '',
      permissions: '',
    },
    {
      title: 'سفارشات',
      path: PATH_MANAGEMENT.management.courier.editCourier.courierInvioce(courierId),
      icon: ICONS.invoice,
      permissions: ['courier.invoicecourier.index'],
    },
    {
      title: 'عمومی',
      path: PATH_MANAGEMENT.management.courier.editCourier.general(courierId),
      icon: ICONS.dashboard,
      permissions: [PermissionPath.courier.show && PermissionPath.courier.update],
    },

    {
      title: 'اطلاعات تکمیلی',
      path: PATH_MANAGEMENT.management.courier.editCourier.further(courierId),
      icon: ICONS.further,
      permissions: ['express-courier.get-notice-call-numbers'],
    },
    {
      title: 'شماره حساب تسویه',
      path: PATH_MANAGEMENT.management.courier.editCourier.courierBankAccount(courierId),
      icon: ICONS.bank,
      permissions: ['courier.bank-account.index'],
    },
    {
      title: 'آدرس',
      path: PATH_MANAGEMENT.management.courier.editCourier.address(courierId),
      icon: ICONS.address,
      permissions: ['courier.address.index'],
    },

    {
      title: 'تراکنش ها',
      path: PATH_MANAGEMENT.management.courier.editCourier.courierTransactions(courierId),
      icon: ICONS.settlement,
      permissions: ['express-courier.show-transactions-of-rials-wallet'],
    },
    {
      title: 'کارمندان',
      path: PATH_MANAGEMENT.management.courier.editCourier.users(courierId),
      icon: ICONS.user,
      permissions: ['courier.user.index'],
    },
  ];
  if (is_back) {
    items.shift();
  }
  return [
    {
      subheader: 'مدیریت',
      items: items,
    },
  ];
};

export default CourierNavConfig;
